import { CardSubtitle } from "../../types/CoreComponents";

export const BarRatingData: CardSubtitle[] = [
  {
    text: "Rating is displayed using ",
    code: "step={*}",
  },
  {
    text: " attr in Rating tag",
  },
];

export const MovingRatingDta: CardSubtitle[] = [
  {
    text: "Movie rating is displayed using ",
    code: "step={4}",
  },
  {
    text: " in react-rating package",
  },
];

export const SquareRatingData: CardSubtitle[] = [
  {
    text: "Square rating is displayed using",
    code: " emptySymbol & fullSymbol ",
  },
];

export const PillRatingData: CardSubtitle[] = [
  {
    text: "Pill rating is displayed using ",
    code: ".pill-rating",
  },
  {
    text: " class",
  },
];

export const ReverseRatingData: CardSubtitle[] = [
  {
    text: "Reversed rating is displayed using ",
    code: 'direction="rtl"',
  },
  {
    text: " Attribute in Rating.",
  },
];

export const StarRatingData: CardSubtitle[] = [
  {
    text: "Star rating is displayed using ",
    code: ".fa-star-o & fa-star",
  },
  {
    text: " class in rating symbol",
  },
];

export const HalfStarRatingData: CardSubtitle[] = [
  {
    text: "Star rating is displayed using ",
    code: ".fa-star-o & fa-star",
  },
  {
    text: " class in rating symbol",
  },
];

export const ThumbUpDownData: CardSubtitle[] = [
  {
    text: "Thumb rating is displayed using ",
    code: ".fa-thumbs-up & .fa-thumbs-down",
  },
  {
    text: " class in rating symbol",
  },
];

export const HeartRatingData: CardSubtitle[] = [
  {
    text: "Heart rating is displayed using ",
    code: ".fa-heart-o & .fa-heart",
  },
  {
    text: " class in rating symbol",
  },
];
